import { render, staticRenderFns } from "./BotonCompraAmigoAbonado.vue?vue&type=template&id=165b045e"
import script from "./BotonCompraAmigoAbonado.vue?vue&type=script&lang=js"
export * from "./BotonCompraAmigoAbonado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports